import {fetch} from 'whatwg-fetch'
import {
  applyCookie,
  removeCookie,
} from './cookies';

export const getLoginURI = () => {
  fetch(`/api/login`)
    .then((response) => response.json())
    .then((response) => {
      window.location.href = response;
    })
    .catch(() => {
      window.location.pathname = '/';
    });
};

export const validateCode = (code, callback) => {
  fetch(`/api/redirect?code=${code}`)
    .then((response) => response.json())
    .then((response) => callback(response))
    .catch(() => {
      window.location.pathname = '/';
    });
};

export const validateCredentials = () => (
  fetch(`/api/validate`, {
    credentials: 'include',
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.data.id && response.data.name) {
        return true;
      }
      return false;
    })
    .catch(() => false)
);

export const getLogoutURI = () => {
  fetch(`/api/logout`)
    .then((response) => response.json())
    .then((response) => window.location.replace(response))
    .catch(() => {
      window.location.pathname = '/';
    });
};

export const refreshBoxToken = () => {
  return fetch(`/api/refreshBoxToken`, {
      credentials: 'include',
    })
    .then( (response) => response.json() )
    .then( (response) => {
      if (response.boxToken) {
        const expiryTime = response.boxToken.acquiredAtMS + response.boxToken.accessTokenTTLMS;
        applyCookie('boxToken', JSON.stringify(response.boxToken), expiryTime);
        return true;
      } else {
        return false;
      }
    })
    .catch( (err) => {
      console.log(err);
      removeCookie('boxToken');
      removeCookie('cognitoToken');
      window.location.pathname = '/';
    })
}
